import React from "react";

let cached = null;
let inflight = null;

const fetchGymTimezone = () => {
  if (inflight) return inflight;
  inflight = fetch("/actions/coach-settings", { credentials: "same-origin" })
    .then((res) => {
      if (!res.ok || res.status === 204) return null;
      return res.json().catch(() => null);
    })
    .then((data) => {
      const tz =
        data && typeof data.timezone === "string" && data.timezone.length > 0
          ? data.timezone
          : null;
      cached = tz;
      return tz;
    })
    .catch(() => null);
  return inflight;
};

export function useGymTimezone() {
  const [tz, setTz] = React.useState(cached);
  React.useEffect(() => {
    let cancelled = false;
    if (cached != null) return undefined;
    fetchGymTimezone().then((value) => {
      if (!cancelled) setTz(value);
    });
    return () => {
      cancelled = true;
    };
  }, []);
  return tz;
}
